import { render, staticRenderFns } from "./PostNewsletter.vue?vue&type=template&id=bfde6c56"
import script from "./PostNewsletter.vue?vue&type=script&lang=js"
export * from "./PostNewsletter.vue?vue&type=script&lang=js"
import style0 from "./PostNewsletter.vue?vue&type=style&index=0&id=bfde6c56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports